import EmployeView from './EmployeView';
import React, {useState, useEffect, useMemo} from 'react';
import './Employe.css';

/**
 * Permet de modifier ou d'ajouter un employé
 * @param {*} props props
 * @return {JSX}
 */
function Employe(props) {
  const [searchInput, setSearchInput] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    setResponsivePageSize();

    window.addEventListener('resize', setResponsivePageSize);
    return () => window.removeEventListener('resize', setResponsivePageSize);
  }, []);

  /**
  * Permet de déterminer le nombre d'éléments a faire afficher dans la page
  */
  function setResponsivePageSize() {
    setPageSize(window.innerWidth <= 600 ? 5 : 15);
  }

  const filteredEmployes = useMemo(() => {
    return props.employes
        .filter((employe) =>
          searchInput
              .toLowerCase()
              .split(' ')
              .every(
                  (term) =>
                    employe.name.toLowerCase().includes(term) ||
              employe.email.toLowerCase().includes(term),
              ),
        );
  }, [searchInput, props.employes]);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, filteredEmployes.length);

  const displayedEmployes = filteredEmployes.slice(startIndex, endIndex);

  /**
  * Gère la searchBar
  * @param {*} e event
  */
  function handleSearchInput(e) {
    setSearchInput(e.target.value);
    setCurrentPage(1);
  }

  /**
   * Gère le changement de page
   * @param {*} newPage la page à afficher
   */
  function handlePageChange(newPage) {
    setCurrentPage(newPage);
  }

  const isButtonDisabled = (symbol) => {
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === Math.ceil(filteredEmployes.length / pageSize) || filteredEmployes.length === 0;
    return symbol.props.icon.iconName === 'angles-left' || symbol.props.icon.iconName === 'angle-left' ? isFirstPage : isLastPage;
  };

  return (
    <div>
      <EmployeView
        searchInput={searchInput}
        handleSearchInput={handleSearchInput}
        handlePageChange={handlePageChange}
        isButtonDisabled={isButtonDisabled}
        displayedEmployes={displayedEmployes}
        employes={props.employes}
        setEmployes={props.setEmployes}
        pageSize={pageSize}
        currentPage={currentPage} />
    </div>
  );
}

export default Employe;
